module.exports = __webpack_public_path__ + "img/trafficInsurance.b9c365a8.jpg";